import React from "react";

export const PageContent = ({ children }) => {
  return (
    <div className="glpartnerform-container">
      <div className="registerbox bg-white">
        {children}
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/modules/AppCore/Component/Layout/PageContentComponent.js